<template>
  <article class="article-page">
    <div class="article-page_content">
      <div class="hgroup">
        <h1 class="heading1">{{ $t(`Правила Программы «${programName}»`) }}</h1>
      </div>
        <div  v-if="showDate" class="article-page_date">
         <span>{{ $t('редакция от 3 сентября 2025 г.') }}</span>
        </div>
      <div class="article-page_nav">
        <ol class="ordered-list">
          <li class="ordered-list_item">
            <a class="link" href="#no1">{{ $t('Общие положения') }}</a></li>
          <li class="ordered-list_item">
            <a class="link" href="#no2">{{ $t('Термины и определения') }}</a></li>
          <li class="ordered-list_item">
            <a class="link" href="#no3">{{ $t('Участие в Программе') }}</a></li>
          <li class="ordered-list_item">
            <a class="link" href="#no4">{{ $t('Порядок начисления Внутриигровой валюты') }}</a>
          </li>
          <li class="ordered-list_item">
            <a class="link" href="#no5">{{ $t('Ответственность') }}</a>
          </li>
          <li class="ordered-list_item">
            <a class="link" href="#no6">{{ $t('Прекращение участия в Программе') }}</a>
          </li>
          <li class="ordered-list_item">
            <a class="link" href="#no7">{{ $t('Изменение и прекращение Программы') }}</a>
          </li>
          <li class="ordered-list_item">
            <a class="link" href="#no8">{{ $t('Прочие условия') }}</a>
          </li>
          <li class="ordered-list_item">
            <a class="link" href="#no9">{{ $t('ПРИЛОЖЕНИЕ 1. Правила начисления Внутриигровой валюты') }}</a>
          </li>
        </ol>
      </div>

      <Component :is="rulesComponent" />
    </div>
  </article>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

import RulesRuTinkoff from '../components/Rules/RulesRuTinkoff'
import RulesBy from '../components/Rules/RulesBy'

const page = {
  RU: {
    tbank: RulesRuTinkoff
  },
  BY: {
    ab: RulesBy
  }
}

@Component
class RulesView extends Vue {
  @Prop({ type: String }) partner
  @State('country') currentCountry

  get rulesComponent () {
    if (!this.currentCountry && this.partner) {
      for (let country of Object.values(page)) {
        if (country[this.partner]) {
          return country[this.partner]
        }
      }
    }
    if (this.partner && page[this.currentCountry][this.partner]) {
      return page[this.currentCountry][this.partner]
    } else {
      const existPartner = Object.keys(page[this.currentCountry])[0]
      this.$router.replace({ params: { partner: existPartner } })
    }
  }

  get showDate () {
    return this.currentCountry === 'RU'
  }

  get programName () {
    const baseCardName = 'Карта Леста'
    const genitiveCaseBankNames = {
      ab: 'Альфа Банка',
      tbank: 'Т-Банка'
    }
    const bankName = genitiveCaseBankNames[this.partner]

    return bankName ? `${baseCardName} от ${bankName}` : baseCardName
  }
}

export default RulesView
</script>

<style lang="scss">
  .article-page {
    margin-bottom: 38px;
    @include media_tablet {
      margin-bottom: 76px;
    }
    @include media_desktop {
      margin-bottom: 97px;
    }
    &_date {
    font-size:18px;
    margin-bottom: 10px;
    }
    &_content {
      @extend %layout;
    }
    &_nav {
      margin-bottom: 42px;
      @include media_tablet {
        margin-bottom: 76px;
      }
      @include media_desktop {
        margin-bottom: 97px;
      }
    }
  }
</style>
